import { sleep } from "../../assets/js/utils/timeout.js";

export class SchulbuchlisteSuche extends HTMLElement {
    constructor() {
        super();
        this.events = ["change"];
        this.updateContainer = this.querySelector("[data-update-container]");
        this.addListener();
    }

    get schulbuchsucheUrl() {
        return this.dataset["schulbuchsucheUrl"];
    }

    get bundesland() {
        return this.querySelector("select[data-name='filterBundesland']");
    }

    get stadt() {
        return this.querySelector("select[data-name='filterStadt']");
    }

    get schule() {
        return this.querySelector("select[data-name='filterSchule']");
    }

    disconnectedCallback() {
        this.removeListener();
    }

    /**
     * Globaler Event-Handler für alle Events.
     * @param event
     */
    handleEvent(event) {
        const { type } = event;
        this[`handle${type}`](event);
    }

    addListener() {
        for (const event of this.events) {
            this.addEventListener(event, this);
        }
    }

    removeListener() {
        for (const event of this.events) {
            this.removeEventListener(event, this);
        }
    }

    async handlechange(event) {
        const { target } = event;
        if (target.name === "slug") {
            return;
        }
        this.showLadeindikator();
        const requestUrl = this.getChangeRequestUrl(event);
        try {
            const response = await fetch(requestUrl);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const html = await response.text();
            if (html) {
                this.updateContainer.innerHTML = html;
            }
            this.focusNewTargetInDOM(target);
        } catch (error) {
            this.showHinweis("schulbuchsuche-warning-filter-update");
            console.error(error);
        } finally {
            this.hideLadeindikator();
        }
    }

    getChangeRequestUrl() {
        const url = new URL(`${window.location.origin}/${this.schulbuchsucheUrl}`);
        const searchParams = new URLSearchParams(url.search);
        if (this.bundesland.value) {
            searchParams.set(this.bundesland.dataset["name"], this.bundesland.value);
        }
        if (this.stadt.value) {
            searchParams.set(this.stadt.dataset["name"], this.stadt.value);
        }
        if (this.schule.value) {
            searchParams.set(this.schule.dataset["name"], this.schule.value);
        }
        searchParams.set("ajax", "true");
        url.search = searchParams.toString();
        return url;
    }

    showLadeindikator() {
        this.querySelector(".ladeindikator").removeAttribute("hidden");
    }

    hideLadeindikator() {
        this.querySelector(".ladeindikator").setAttribute("hidden", "");
    }

    async showHinweis(messageid) {
        const hinweis = document.createElement("merkzettel-hinweis");
        try {
            hinweis.render(this, messageid);
            await sleep(100);
            hinweis.open();
        } catch (error) {
            console.error("SchulbuchlisteSuche", "showHinweis", error);
        }
    }

    async focusNewTargetInDOM(element) {
        if (!element) return;
        let targetid = null;
        if (element.hasAttribute("id")) {
            targetid = element.id;
        }
        if (element.closest("[id]")) {
            targetid = element.closest("[id]").getAttribute("id");
        }
        if (targetid) {
            await sleep(1);
            const newDomElement = this.querySelector(`[id="${targetid}"]`);
            return newDomElement.focus();
        }
        // Als Fallback fokussieren wir den ersten Eintrag der Filter
        this.querySelector(".filter select").focus();
    }
}


if (!customElements.get("schulbuchliste-suche")) {
    customElements.define("schulbuchliste-suche", SchulbuchlisteSuche);
}
